import dayjs from "dayjs";
import es from "dayjs/locale/es.js";

dayjs.locale("es");

export default {
  ...es,
  customFormats: {
    Ll: "D MMM. YYYY",
    Lwy: "D [de] MMMM [del] YYYY",
  },
  hours_short: "h",
  minutes_short: "min",
};
